import { Box, Grid, Stack, Container, Typography } from '@mui/material';
import BackButton from 'src/components/ui-kit/back-button';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { toastError } from 'src/utils/format-error';
import { useForm } from 'react-hook-form';
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import { LoadingButton } from '@mui/lab';
import { useGoBack } from 'src/hooks/use-go-back';
import { paths } from 'src/routes/paths';
import axios, { endpoints } from 'src/utils/axios';
import { enqueueSnackbar } from 'notistack';

const Schema = Yup.object().shape({
  startRefCode: Yup.string()
    .required('จำเป็นต้องระบุรหัสขึ้นต้น')
    .length(4, 'รหัสขึ้นต้นต้องมีความยาว 4 หลัก'),
  amount: Yup.number()
    .required('จำเป็นต้องระบุจำนวน')
    .moreThan(0, 'จำนวนต้องมากกว่า 0')
    .lessThan(31, 'จำนวนต้องไม่เกิน 30 ต่อการสร้าง 1 ครั้ง'),
});

const defaultValues = {
  startRefCode: '',
  amount: 0,
};

export default function InviteCodeCreateView() {
  const back = useGoBack();

  const methods = useForm({
    mode: 'onChange',
    resolver: yupResolver(Schema),
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting, isValid },
  } = methods;

  const onSubmit = handleSubmit(async (formValue) => {
    try {
      const { data } = await axios.post(endpoints.referrals.create, {
        startRefCode: formValue.startRefCode.toUpperCase(),
        amount: Number(formValue.amount),
      });
      if (!data) {
        throw new Error('ไม่สามารถสร้างรหัสเชิญได้');
      }
      back(paths.management.inviteCode.root);
      enqueueSnackbar('สร้างรหัสเชิญสำเร็จ');
    } catch (error) {
      toastError(error);
    }
  });

  return (
    <Container>
      <BackButton />
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <Stack spacing={4}>
          <Typography variant="h4">สร้างรหัสเชิญ</Typography>

          <Grid container>
            <Grid item xs={12} md={4}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <RHFTextField
                    name="startRefCode"
                    label="รหัสขึ้นต้น 4 หลัก"
                    placeholder="รหัสขึ้นต้น"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{ style: { textTransform: 'uppercase' } }}
                    mask="****"
                  />
                </Grid>
                <Grid item xs={12}>
                  <RHFTextField
                    type="number"
                    name="amount"
                    label="จำนวนรหัสที่ต้องการสร้าง"
                    placeholder="จำนวน"
                    InputLabelProps={{ shrink: true }}
                    helperText="รหัสสามารถสร้างได้ไม่เกิน 30 รหัสต่อการสร้าง 1 ครั้ง"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Box>
            <LoadingButton
              variant="contained"
              type="submit"
              color="warning"
              loading={isSubmitting}
              disabled={!isValid}
            >
              สร้างรหัสเชิญ
            </LoadingButton>
          </Box>
        </Stack>
      </FormProvider>
    </Container>
  );
}
